// extracted by mini-css-extract-plugin
var _1 = "OQORwW6OrV";
var _2 = "PbIAriyXbi";
var _3 = "_T9z_LKYz9";
var _4 = "tIGm4ezWut";
export { _1 as "disabled", _2 as "icon", _3 as "label", _4 as "root" }
